// Pure time / frame helpers for the AOE2 curation editor.
//
// No DOM, no Stimulus. All functions are pure and unit-tested.
// The single FPS constant (30) is authoritative for this editor —
// it must stay in sync with the Remotion template (useVideoConfig()
// returns 30 for the aoe2-replay-short composition).

export const FPS = 30

// Convert a time in seconds to the nearest frame index (0-based).
// Uses Math.round so that e.g. 0.517 s → frame 16 (≈ 15.5 rounded up).
export function secondsToFrame(seconds) {
  return Math.round(seconds * FPS)
}

// Convert a frame index back to seconds.
export function frameToSeconds(frame) {
  return frame / FPS
}

// Generic clamp.
export function clamp(min, max, value) {
  return Math.max(min, Math.min(max, value))
}

// Format a duration in seconds to a human-readable "M:SS" or "H:MM:SS" string.
// Examples: 90 → "1:30", 3661 → "1:01:01", 45 → "0:45".
export function formatDuration(totalSeconds) {
  const s = Math.floor(totalSeconds)
  const hours = Math.floor(s / 3600)
  const minutes = Math.floor((s % 3600) / 60)
  const secs = s % 60
  const mm = String(minutes).padStart(2, "0")
  const ss = String(secs).padStart(2, "0")
  if (hours > 0) {
    return `${hours}:${mm}:${ss}`
  }
  return `${minutes}:${ss}`
}
